var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tooltip',{attrs:{"custom-class":"main-tooltip","target":String(_vm.target),"placement":_vm.placement,"triggers":"hover"}},[(_vm.isHtml)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.tooltipValue)}}):[_vm._v(_vm._s(_vm.tooltipValue))]],2)}
var staticRenderFns = []

export { render, staticRenderFns }